<div class="create-contact-group-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ (data ? 'CONTACTS.EDIT_GROUP_TITLE' : 'CONTACTS.CREATE_GROUP_TITLE') | translate }}</h2>
    <div class="header-actions">
      @if (canDelete$ | async) {
        <button
          mat-icon-button
          type="button"
          class="icon-button delete-icon-button"
          [disabled]="isSaving"
          (click)="confirmDelete()"
          data-cy="delete-contact-group">
          <mat-icon>delete</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        mat-dialog-close
        class="icon-button close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form
      #createGroupForm="ngForm"
      (ngSubmit)="handleCreate()">
      <div class="form-group">
        <label class="form-label">{{ 'CONTACTS.CREATE_GROUP_NAME_LABEL' | translate }}</label>
        <mat-form-field
          appearance="outline"
          class="full-width">
          <input
            matInput
            [(ngModel)]="groupName"
            name="groupName"
            placeholder="{{ 'CONTACTS.CREATE_GROUP_NAME_PLACEHOLDER' | translate }}"
            required
            pattern=".*\S.*" />
        </mat-form-field>
      </div>

      <div class="form-group">
        <label class="form-label">{{ 'CONTACTS.CREATE_GROUP_DESCRIPTION_LABEL' | translate }}</label>
        <mat-form-field
          appearance="outline"
          class="full-width">
          <textarea
            matInput
            [(ngModel)]="groupDescription"
            name="groupDescription"
            rows="2"
            placeholder="{{ 'CONTACTS.CREATE_GROUP_DESCRIPTION_PLACEHOLDER' | translate }}"></textarea>
        </mat-form-field>
      </div>

      @if (canShowSharedSection$ | async) {
        <div class="form-group">
          <mat-checkbox
            color="primary"
            [(ngModel)]="isShared"
            (ngModelChange)="onSharedToggled()"
            name="isShared">
            {{ 'CONTACTS.CREATE_GROUP_SHARED_LABEL' | translate }}
          </mat-checkbox>
          @if (isShared) {
            <p class="shared-hint">{{ 'CONTACTS.CREATE_GROUP_SHARED_HINT' | translate }}</p>
          }
        </div>
        @if (isShared) {
          <div class="form-group">
            <label class="form-label">{{ 'CONTACTS.CREATE_GROUP_MIN_ROLE_MANAGE_LABEL' | translate }}</label>
            <mat-form-field
              appearance="outline"
              class="full-width">
              <mat-select
                [(ngModel)]="minRoleManage"
                name="minRoleManage">
                @for (role of sharedContactRoles; track role) {
                  <mat-option [value]="role">{{
                    'CONTACTS.SHARED_CONTACT_ROLE_' + role.toUpperCase() | translate
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label class="form-label">{{ 'CONTACTS.CREATE_GROUP_MIN_ROLE_DELETE_LABEL' | translate }}</label>
            <mat-form-field
              appearance="outline"
              class="full-width">
              <mat-select
                [(ngModel)]="minRoleDelete"
                name="minRoleDelete">
                @for (role of sharedContactRoles; track role) {
                  <mat-option [value]="role">{{
                    'CONTACTS.SHARED_CONTACT_ROLE_' + role.toUpperCase() | translate
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label class="form-label">{{ 'CONTACTS.CREATE_GROUP_MANAGERS_LABEL' | translate }}</label>
            <p class="shared-hint">{{ 'CONTACTS.CREATE_GROUP_MANAGERS_HINT' | translate }}</p>
            <app-contact-chips
              appearance="outline"
              [selectedChipContacts]="managers"
              (selectedChipContactsChange)="managers = $event"
              [placeholder]="'CONTACTS.CREATE_GROUP_USER_SEARCH_PLACEHOLDER' | translate">
            </app-contact-chips>
          </div>
        }
      }
    </form>

    <mat-divider></mat-divider>

    <div class="contact-picker">
      <mat-form-field
        appearance="outline"
        class="full-width search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [(ngModel)]="search"
          (ngModelChange)="handleSearchChange()"
          placeholder="{{ 'CONTACTS.CREATE_GROUP_SEARCH_PLACEHOLDER' | translate }}" />
      </mat-form-field>

      <div class="contact-picker-header">
        <span class="contacts-count"
          >{{ 'CONTACTS.ALL_CONTACTS' | translate | uppercase }} ({{ filteredContacts().length }})</span
        >
        <label class="select-all">
          <span>{{ 'CONTACTS.CREATE_GROUP_SELECT_ALL' | translate }}</span>
          <mat-checkbox
            [checked]="isAllVisibleSelected()"
            (change)="toggleSelectAllVisible()">
          </mat-checkbox>
        </label>
      </div>

      @if (filteredContacts().length === 0) {
        <div class="no-contacts">{{ 'CALLS.NO_MATCHES_FOUND_TEXT' | translate }}</div>
      } @else {
        <cdk-virtual-scroll-viewport
          itemSize="56"
          class="contact-picker-list">
          <label
            *cdkVirtualFor="let contact of filteredContacts(); trackBy: trackByContactId"
            class="contact-row"
            [class.selected]="isSelected(contact)">
            <app-name-coin [contact]="contact"></app-name-coin>
            <div class="contact-info">
              <span class="contact-name">{{ contact.fullName }}</span>
              <span class="contact-subtext">{{ contactSubtext(contact) }}</span>
            </div>
            <mat-checkbox
              [checked]="isSelected(contact)"
              (change)="toggleContact(contact)">
            </mat-checkbox>
          </label>
        </cdk-virtual-scroll-viewport>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <span class="selected-count"
      >{{ selectedIds().size }} {{ 'CONTACTS.CREATE_GROUP_CONTACTS_SELECTED' | translate }}</span
    >
    <div class="actions">
      <button
        mat-button
        mat-dialog-close
        type="button"
        [disabled]="isSaving"
        class="cancel-btn">
        {{ 'CONTACTS.CREATE_GROUP_CANCEL' | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        (click)="handleCreate()"
        [disabled]="!createGroupForm.valid || isSaving || selectedIds().size === 0"
        class="create-btn">
        {{ (data ? 'CONTACTS.SAVE' : 'CONTACTS.CREATE_GROUP_CREATE') | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
